import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Typography,
} from '@material-ui/core';

import EventListItem from '../../main/components/EventListItem';
import NewsListItem from '../../main/components/NewsListItem';

import * as mainActions from '../../main/actions';
import classes from '../../css/getCSS';


class RightPanel extends Component {
  componentDidMount() {
    if (!this.props.eventsLoaded) {
      this.props.getEvents(this.props.site.id);
    }
    if (!this.props.newsLoaded) {
      this.props.getNews(this.props.site.id);
    }
  }

  render() {
    let event = null;
    if (this.props.eventList && this.props.eventList.length > 0) {
      const rand = this.props.eventList[Math.floor(Math.random() * this.props.eventList.length)];
      event = (
        <EventListItem
          showCaption
          {...rand}
        />
      );
    }

    let news = null;
    if (this.props.newsList && this.props.newsList.length > 0) {
      const rand = this.props.newsList[Math.floor(Math.random() * this.props.newsList.length)];
      news = (
        <NewsListItem
          showCaption
          {...rand}
        />
      );
    }

    return (
      <div className={classes.rightWrapper}>
        <Typography variant="title">Current News &amp; Events</Typography>
        <br />
        {event}
        {news}
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    eventList: state.main.eventList,
    newsList: state.main.newsList,
    eventsLoaded: state.main.eventsLoaded,
    newsLoaded: state.main.newsLoaded,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(mainActions.onUnmount()),
    getEvents: (siteID, url) => dispatch(mainActions.getEvents(siteID, url)),
    getNews: (siteID, url) => dispatch(mainActions.getNews(siteID, url)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RightPanel);



// WEBPACK FOOTER //
// ./src/dashboard/containers/RightPanel.js